exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".request-list{max-height:300px;overflow-x:hidden;overflow-y:scroll;border:1px solid #b4b4b4;border-radius:8px}", ""]);

